var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5934 8.33187L9.91406 10.0112L14.6611 14.7582L16.3404 13.0789L11.5934 8.33187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8557 5.9168C14.3836 5.9168 15.6266 4.67388 15.6266 3.14596C15.6266 2.6868 15.4999 2.2593 15.302 1.8793L13.1645 4.0168L11.9849 2.83721L14.1224 0.699714C13.7424 0.501797 13.3149 0.37513 12.8557 0.37513C11.3278 0.37513 10.0849 1.61805 10.0849 3.14596C10.0849 3.47055 10.1482 3.7793 10.2511 4.0643L8.78656 5.52888L7.3774 4.11971L7.93948 3.55763L6.82323 2.44138L8.50156 0.763047C7.57531 -0.163203 6.07115 -0.163203 5.1449 0.763047L2.3424 3.56555L3.45865 4.6818H1.22615L0.664062 5.24388L3.46656 8.04638L4.02865 7.4843V5.24388L5.1449 6.36013L5.70698 5.79805L7.11615 7.20721L1.2499 13.0735L2.92823 14.7518L11.9374 5.75055C12.2224 5.85346 12.5311 5.9168 12.8557 5.9168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.fe057800d5044dcc6e63b1944dd22466.svg";
export { ForwardRef as ReactComponent };